import {useContext, useEffect, useState} from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Container} from "react-bootstrap";
import API, { HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import PracticeItem from "../components/PracticeItem";
import {PracticeCategory} from "../models/PracticeCategory";
import PracticeView from "../components/PracticeView";
import {useLocation} from "react-router-dom";
import RenewSubscription from "../components/RenewSubscription";

export default function Practice() {
    const app = useContext(AppContext)
    const [categories, setCategories] = useState([])
    const { enqueueSnackbar } = useSnackbar()
    const location = useLocation()
    const initialCategory = location?.state?.initialCategory;
    const [currentCat, setCurrentCat] = useState(null)

    useEffect(() => {
        if(currentCat === null)
            getCategories()

    }, [currentCat, app.user.current_course])

    const getCategories = async () => {
        try {
            const res = await API({
                method: 'GET',
                url: `/practice/${app.user.current_course}/categories`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            let activeCategory = null;
            let categories = res.data.items.map((jsonData, idx) => {
                let pc = new PracticeCategory(jsonData)
                if(initialCategory && initialCategory === pc.ID)
                    activeCategory = pc

                return pc
            })
            setCategories(categories)
            if(activeCategory) {
                setCurrentCat(activeCategory)
            }
        }
        catch(e) {
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <div id="page-practice" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container fluid className="practice-container">
                {categories.map((category, idx) => {
                    return <PracticeItem key={'practice-cat-' + idx} category={category} currentCat={currentCat}
                                        setCurrentCat={setCurrentCat} recommended={false}
                                        ref={null} />
                })}
            </Container>
        </div>
        {currentCat !== null && <PracticeView currentCat={currentCat} setCurrentCat={setCurrentCat} />}
    </div>
}